import React, { useEffect } from 'react';
import LogsListView, { LogsListViewProps, LogEntry } from './LogsListView';
import { useLastLogs } from '../../../../features/Jouly/hooks';
import { Point } from '../../../../features/Jouly/types/types';


export interface LogsListPresenterProps {
  deviceId?: string;
  maxHeight?: string;
  autoRefresh?: boolean;
  refreshInterval?: number;
}

export default function LogsListPresenter({
  deviceId,
  maxHeight = '400px',
  autoRefresh = true,
  refreshInterval = 30000 // 30 seconds
}: LogsListPresenterProps) {
  const { lastLogsQuery } = useLastLogs(deviceId, 50);

  // Transform API data to LogEntry format
  const transformLogs = (apiLogs: Point[] | undefined | null): LogEntry[] => {
    if (!apiLogs || !Array.isArray(apiLogs)) return [];
    
    return apiLogs.map((log, index) => ({
      id: log.Time || `log-${index}`,
      timestamp: log.Time || log.Time || new Date().toISOString(),
      message: log.Value.toString() || log.Value.toString() || 'Log entry',
     
    }));
  };

  const logs = transformLogs(lastLogsQuery.data || []);
  const isLoading = lastLogsQuery.isLoading;

  // Auto-refresh functionality
  useEffect(() => {
    if (!autoRefresh || !deviceId) return;

    const interval = setInterval(() => {
      lastLogsQuery.refetch();
    }, refreshInterval);

    return () => clearInterval(interval);
  }, [autoRefresh, refreshInterval, deviceId, lastLogsQuery]);

  const viewProps: LogsListViewProps = {
    logs,
    isLoading,
    maxHeight
  };

  return <LogsListView {...viewProps} />;
}
